import React, { type FunctionComponent, type ReactElement } from 'react';

type Props = {
  value: string;
};

const Highlight: FunctionComponent<Props> = (props) => {
  const inputText = props.value;
  const terms = inputText.match(/\[\[mark]](.*?)\[\[\/mark]]/g);
  const splitText = inputText.split(/\[\[mark]](.*?)\[\[\/mark]]/);

  const reactArray = splitText.reduce<ReactElement[]>((acc, value, index) => {
    if (value && terms) {
      if (terms.indexOf(`[[mark]]${value}[[/mark]]`) !== -1) {
        acc.push(<mark key={index}>{value}</mark>);
      } else {
        acc.push(<React.Fragment key={index}>{value}</React.Fragment>);
      }
    }
    return acc;
  }, []);

  return <>{reactArray}</>;
};

export default Highlight;
